import React from "react";
import { FaCode, FaWordpress, FaPaintBrush, FaBullhorn } from "react-icons/fa";

const services = [
  {
    icon: <FaCode size={34} />,
    title: "Web Development",
    description:
      "Custom websites, full-stack solutions, E-commerce Website, bug fixing and redesigns to boost your online presence.",
  },
  {
    icon: <FaWordpress size={34} />,
    title: "WordPress Websites",
    description:
      "Business sites, blogs and e-commerce development built with WordPress for simple and easy management.",
  },
  {
    icon: <FaPaintBrush size={34} />,
    title: "Logo & Branding Design",
    description:
      "Custom logo design and complete brand identity kits to give your business a unique look.",
  },
  {
    icon: <FaBullhorn size={34} />,
    title: "Paid Ads",
    description:
      "Targeted ad campaigns on Google, Facebook, Instagram and other digital platforms to grow business.",
  },
];

export default function Services() {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="services" className="py-5" style={{ background: "#1a1a2e" }}>
      <div className="container">
        <div className="text-center mb-5 text-white">
          <h2 className="fw-bold display-6">My Services</h2>
          <p className="text-light">
            Professional services to grow your business online
          </p>
          <div
            className="mx-auto"
            style={{
              width: "80px",
              height: "3px",
              background: "linear-gradient(135deg, #ff4e50, #f9d423)",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        <div className="row g-4">
          {services.map((service, idx) => (
            <div key={idx} className="col-12 col-md-6 col-lg-3">
              <div
                className="h-100 text-center p-4 rounded-4"
                style={{
                  background: "#162447",
                  color: "#fff",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 35px rgba(255, 78, 80, 0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.5)";
                }}
              >
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 shadow"
                  style={{
                    width: 80,
                    height: 80,
                    background: "linear-gradient(135deg, #ff4e50, #f9d423)",
                    color: "#fff",
                  }}
                >
                  {service.icon}
                </div>
                <h5 className="fw-bold mb-2">{service.title}</h5>
                <p className="small text-light">{service.description}</p>
                <button
                  onClick={scrollToContact}
                  className="btn mt-3 fw-semibold"
                  style={{
                    background: "linear-gradient(135deg, #ff4e50, #f9d423)",
                    color: "#fff",
                    border: "none",
                  }}
                >
                  Get Started
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
